import React from 'react';
import CourseCard from '../components/RecordedCourseCard';
import FAQItem from '../components/FAQItem';
import Testimonial from '../components/Testimonial';
import '../styles/header.css';
import '../styles/hero.css';
import '../styles/courses.css';
import '../styles/testimonials.css';
import '../styles/faq.css';
import '../styles/footer.css';
import '../styles/benifitsComparision.css';

const PremiumCoursesPage = () => {
  const courses = [
    {
      id: 'apex-mastery',
      title: 'Apex Basics to Advanced',
      description: 'Master Apex programming from fundamentals to advanced concepts with real-world projects.',
      price: '$199',
      features: ['60+ lessons', '10 projects', 'Downloadable code', 'Certificate'],
    },
    {
      id: 'lwc-interview',
      title: 'LWC Interview Preparation Kit',
      description: 'Ace your Lightning Web Components interviews with our comprehensive preparation course.',
      price: '$149',
      features: ['50+ lessons', 'Mock interviews', 'Common questions', 'Certificate'],
    },
    {
      id: 'apex-interview',
      title: 'Apex Interview Preparation Kit',
      description: 'Prepare for Salesforce developer interviews with focused Apex training and practice.',
      price: '$149',
      features: ['45+ lessons', 'Coding exercises', 'Scenario-based questions', 'Certificate'],
    },
  ];

  const faqs = [
    {
      question: 'How do self-paced courses work?',
      answer: 'After purchase, you get instant access to all videos, resources, and updates forever! Learn at your own pace with lifetime access.'
    },
    {
      question: 'Is there a money-back guarantee?',
      answer: 'Yes! We offer a 7-day refund if the course doesn\'t meet your expectations.'
    },
    {
      question: 'Do I need any prior experience?',
      answer: 'Most of our courses are designed for all levels, with clear prerequisites mentioned for each course.'
    }
  ];

  const testimonials = [
    {
      quote: "The Apex Mastery course helped me transition from admin to developer in just 3 months. The projects were incredibly realistic.",
      author: "Priya K., Salesforce Developer"
    },
    {
      quote: "I aced 3 interviews after completing the LWC preparation kit. The mock interview section was game-changing!",
      author: "Rahul S., Frontend Developer"
    }
  ];

  return (
    <div className="home-page">
      {/* <Header /> */}
      
      <section className="phero">
        <div className="phero-content">
          <h1>Master In-Demand Salesforce Skills on Your Schedule</h1>
          <p>Lifetime access to structured, expert-led courses with practical projects, certifications, and dedicated support.</p>
          <a href="#courses" className="pcta-button">Explore Courses</a>
        </div>
      </section>

  

      <section id="courses" className="featured-courses">
        <h2>Featured Salesforce Courses</h2>
        <div className="courses-grid">
          {courses.map(course => (
            <CourseCard key={course.id} course={course} />
          ))}
        </div>
      </section>

      <section className="benefits">
        <h2>Why Choose Our Self-Paced Mastery Courses?</h2>
        <div className="benefits-grid">
          <div className="benefit-item">
            <div className="benefit-icon">✅</div>
            <h3>Self-Paced Learning</h3>
            <p>No deadlines, learn anytime at your convenience.</p>
          </div>
          <div className="benefit-item">
            <div className="benefit-icon">✅</div>
            <h3>Industry-Ready Skills</h3>
            <p>Job-focused curriculums designed by Salesforce experts.</p>
          </div>
          <div className="benefit-item">
            <div className="benefit-icon">✅</div>
            <h3>Downloadable Resources</h3>
            <p>Get notes, templates, and code files for offline use.</p>
          </div>
          <div className="benefit-item">
            <div className="benefit-icon">✅</div>
            <h3>Certification</h3>
            <p>Earn certificates to boost your resume.</p>
          </div>
        </div>
      </section>

      <section className="comparison">
        <h2>How We Compare to Free Content</h2>
        <table>
          <thead>
            <tr>
              <th>Feature</th>
              <th>Free YouTube Courses</th>
              <th>Self-Paced Mastery Courses</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Structured Curriculum</td>
              <td>❌ No</td>
              <td>✅ Yes</td>
            </tr>
            <tr>
              <td>Downloadable Resources</td>
              <td>❌ No</td>
              <td>✅ Yes</td>
            </tr>
            <tr>
              <td>Certificates</td>
              <td>❌ No</td>
              <td>✅ Yes</td>
            </tr>
            <tr>
              <td>Q&A Support</td>
              <td>❌ No</td>
              <td>✅ Yes</td>
            </tr>
            <tr>
              <td>Lifetime Access</td>
              <td>❌ Maybe</td>
              <td>✅ Yes</td>
            </tr>
          </tbody>
        </table>
      </section>

      {/* <section className="testimonials-section">
        <h2>What Our Students Say</h2>
        <div className="testimonials-container">
          {testimonials.map((testimonial, index) => (
            <Testimonial key={index} testimonial={testimonial} />
          ))}
        </div>
      </section> */}

      <section className="faq-section">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-container">
          {faqs.map((faq, index) => (
            <FAQItem key={index} faq={faq} />
          ))}
        </div>
      </section>

      <section className="cta-section">
        <h2>Start Mastering Salesforce Today!</h2>
        <a href="#courses" className="cta-button">Buy Now</a>
      </section>

      <footer className="page-footer">
        <p>© {new Date().getFullYear()} Salesforce Mastery Courses. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default PremiumCoursesPage;